var map = {
	"./Badges.svg": "a281",
	"./ChildChallenge.svg": "6575",
	"./ChildView.svg": "1cf8",
	"./FAQ.svg": "9f4a",
	"./GoalsParents.svg": "5489",
	"./Home.svg": "305b",
	"./LogOut.svg": "9c0e",
	"./ParentView.svg": "0978",
	"./ProblemSolving.svg": "ef4c",
	"./Progress.svg": "20fb",
	"./Rewards.svg": "4c75",
	"./Settings.svg": "6aee",
	"./SkillVisual.svg": "54bc",
	"./Surveys.svg": "6c79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d90";